<template>
    <el-container class="appModelMenu">
        <el-aside width="229px">
             <div :style="activeStyle()">
                <div  class="el-menu-vertical-demo">
                  <el-menu
                          :default-active="defaultAppIndex"
                          v-for="(appSystem, sysIndex) in appSystemlList"
                          :key="appSystem.id"
                          :index="appSystem.id"
                          :unique-opened="true"
                          @open="handleOpen"
                          @close="handleClose"
                          :collapse="isCollapse?false:true"
                          >
                          <el-submenu  :index="appSystem.id">
                              <template slot="title">
                                  <span slot="title">
                                      {{appSystem.name}}
                                  </span>
                              </template>
                              <el-menu-item
                                  v-for="(subModel, smIndex) in appSystem.subModel"
                                  :key="subModel.id"
                                  :index="subModel.id"
                                  @click="handleClickMenu(subModel,appSystem.id,appSystem.name)"
                                  >
                                  <span slot="title">
                                      <i class="el-icon-s-platform" v-if="subModel.modelType==2"></i>
                                      <i class="el-icon-s-data" v-if="subModel.modelType==3"></i>
                                      <i class="el-icon-s-check" v-if="subModel.modelType==4"></i>
                                      <i class="iconfont icon-other-yibiao" v-if="subModel.modelType==5"></i>
                                      <i class="el-icon-tickets" v-if="subModel.modelType==1||subModel.modelType==0"></i>
                                      {{subModel.name}}
                                  </span>
                              </el-menu-item>
                              <el-submenu
                                  v-for="(application, appIndex) in appSystem.children"
                                  :key="application.id"
                                  :index="application.id"
                                  >
                                    <span slot="title">
                                        {{application.name}}
                                    </span>
                                        <el-menu-item
                                            v-for="(model, modelIndex) in application.children"
                                            :key="model.id"
                                            :index="model.id"
                                            @click="handleClickMenu(model,application.id,appSystem.name)"
                                            >
                                            <span slot="title">
                                                <i class="el-icon-s-platform" v-if="model.modelType==2"></i>
                                                <i class="el-icon-s-data" v-if="model.modelType==3"></i>
                                                <i class="el-icon-s-check" v-if="model.modelType==4"></i>
                                                <i class="iconfont icon-other-yibiao" v-if="model.modelType==5"></i>
                                                <i class="el-icon-tickets" v-if="model.modelType==1||model.modelType==0"></i>
                                                {{model.name}}
                                            </span>
                                        </el-menu-item>
                              </el-submenu>
                          </el-submenu>
                  </el-menu>
                </div>
            </div>
        </el-aside>
    </el-container>
</template>

<script>
  export default {
      data () {
          return {
              isCollapse: true
          };
      },
      computed: {
          // defaultActive() {
          //     return '/' + this.$route.path.split('/').reverse()[0];
          // }
      },
      created () {
          this._initPage();
      },
      props: {
          appSystemlList: {
              type: Array
          },
          defaultAppIndex: {
              type: String
          },
          fullScreen: {
              type: Boolean,
              default: false
          },
          isNewMenu: {// 是否新菜单引用
              type: Boolean,
              default: false
          }
      },
      methods: {
          _initPage () {
              if (this.defaultAppIndex !== '') {
                  this.handleClickMenu({id: this.defaultAppIndex});
              }
          },
          handleOpen (key, keyPath) {
              //   console.log("open: "+key+";  "+keyPath);
              //   this.defaultAppIndex="a0200ff2a060451596c6be269d0e8e17";
          },
          handleClose (key, keyPath) {
              //    console.log("close: "+key+";  "+keyPath);
          },
          //   handleSelect(key, keyPath){
          //     //   console.log("select: "+key+";  "+keyPath);
          //       this.$emit('nodeClick', keyPath);
          //   },
          handleClickMenu (model, appId, appName) {
              // console.log(model);
              model.appId = appId;
              model.appName = appName;
              this.$emit('nodeClick', model);
          },
          changeSwitch () {
              let width = this.isCollapse ? '230px' : '35px';
              this.$emit('setMenuWidth', width);
          },
          activeStyle () {
              let style = {};
              if (this.fullScreen) {
                  style = {
                      'height': '575px',
                      'overflow-y': 'auto'
                  };
              } else {
                  style = {
                      'height': 'auto',
                      'overflow-y': 'auto'
                  };
              }
              return style;
          }
      }
  };
</script>

<style>
  /* .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 200px;
  } */
.sidebar-container,
.el-menu {
    height: 100%;
    overflow: auto;
}
.el-aside,
.el-main {
    overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/ApplicationMenu/ApplicationMenu.vue